import React from 'react';
import PropTypes from 'prop-types';
import TimeLine from './timeLine';
import { reduxForm } from 'redux-form';
import messages from '../../../text/messages';
import { minutesFraction } from '../../../utilities/time';
import { FormattedMessage } from 'react-intl';

class WorkDay extends React.Component {
    constructor(props) {
        super(props);
        this.renderTime = this.renderTime.bind(this);
    }

    renderTime() {
        const { disabled, isPreview, date, handleAddTime, timeline, isMobile } = this.props;
        const { totallMins, totalTime, shifts } = timeline;

        return (
            <div className={`row time`}>
                {disabled || isPreview ? (
                    <div className={`col-xs-12 ${isMobile ? 'left-zero' : ''}`}>
                        <span className={`${isPreview ? 'preview-time' : 'disabled-time'}`}>
                            {parseInt(totalTime.hours, 10)} {minutesFraction(totalTime.minutes)} h
                        </span>
                    </div>
                ) : (
                    <div className="col-xs-12">
                        <div className="row">
                            <div className={`col-xs-6 text-center ${isMobile ? 'right-zero' : ''}`}>
                                {!!totallMins && (
                                    <span className={`${isPreview ? 'preview-time' : 'disabled-time'}`}>
                                        {parseInt(totalTime.hours, 10)} {minutesFraction(totalTime.minutes)} h
                                    </span>
                                )}
                            </div>
                            <div className="col-xs-6">
                                {!isPreview &&
                                    !disabled &&
                                    (!totallMins ? (
                                        <span className="button add" onClick={() => handleAddTime(date, totalTime, shifts)}>
                                            <FormattedMessage {...messages.add} />
                                        </span>
                                    ) : (
                                        <span className="button edit" onClick={() => handleAddTime(date, totalTime, shifts)}>
                                            <FormattedMessage {...messages.edit} />
                                        </span>
                                    ))}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    render() {
        const { date, isPreview, job, timeline, isMobile } = this.props;
        const isW2 = job.classify_result !== 'ic';
        const timelineSize = isPreview ? 9 : 7;
        const mobTimeSize = isPreview ? 9 : 7;

        return (
            <div className="work-day">
                <div className="row">
                    <div className="col-xs-12 col-sm-1">
                        <div className={isMobile ? `wokr-day-date ${isW2 ? '' : 'wokr-day-date-and-input'}` : ''}>
                            <div className="day">{date.format('ddd')}</div>
                            <div className="date">{date.format('MM/DD')}</div>
                        </div>
                    </div>
                    <div
                        className={`col-xs-${mobTimeSize} col-sm-${timelineSize - 1} col-lg-${timelineSize} ${
                            !isMobile || (isMobile && !isPreview) ? 'right-zero' : ''
                        }`}
                    >
                        <TimeLine isMobile={isMobile} isW2={isW2} {...timeline} />
                    </div>
                    <div
                        className={`col-xs-${12 - mobTimeSize} col-sm-${12 - timelineSize} col-lg-${11 - timelineSize} timetable-input ${
                            isMobile ? 'left-zero' : ''
                        }`}
                    >
                        {this.renderTime()}
                    </div>
                </div>
            </div>
        );
    }
}

WorkDay.propTypes = {
    timeline: PropTypes.object,
    date: PropTypes.object,
    disabled: PropTypes.bool,
    isPreview: PropTypes.bool,
    jobtimeline: PropTypes.object,
    isMobile: PropTypes.bool
};

WorkDay = reduxForm({
    destroyOnUnmount: false,
    enableReinitialize: true,
    forceUnregisterOnUnmount: true,
    onChange: (values, _, props) => {
        const { job, timesheet, day, initialValues, save, timeline, dirty } = props;
        if ((values.hours !== initialValues.hours || values.minutes !== initialValues.minutes) && dirty) {
            const regularShift = timeline.shifts.find(s => s.type === 'regular');
            const minutes = 60 * parseInt(values.hours, 10) + parseInt(values.minutes, 10);
            const shift = {
                job_id: job.id,
                project_id: values.project_id,
                timesheet_id: timesheet.id,
                time_in: day ? day.clone() : undefined,
                minutes: minutes,
                id: regularShift ? regularShift.id : undefined
            };
            save(shift);
        }
    }
})(WorkDay);

export default WorkDay;



// WEBPACK FOOTER //
// ./src/pages/timekeeping/components/workDay.jsx